export default () => {
  const clickTabSelectorHandler = (e) => {
    e.preventDefault();
    const el = e.target;
    if (el.classList.contains('active')) {
      return;
    }

    const theMostModule = el.closest('.the-most');
    theMostModule.querySelectorAll('.tab__header__selector span').forEach((tab) => {
      if (tab.classList.contains('active')) {
        tab.classList.remove('active');
      } else {
        tab.classList.add('active');
      }
    });
    const { target } = el.dataset;
    theMostModule.querySelectorAll('.tab__content').forEach((list) => {
      if (list.dataset.target === target) {
        list.classList.add('active');
      } else {
        list.classList.remove('active');
      }
    });
  };

  $(() => {
    document.querySelectorAll('.the-most .tab__header__selector span').forEach((item) => {
      item.addEventListener('click', clickTabSelectorHandler);
    });
  });
};
